import {
  disabledNft1,
  disabledNft2,
  disabledNft3,
  disabledNft4,
  disabledNft5,
  disableGame1,
  disableGame2,
  disableGame3,
  disableGame4,
  scholarCover1,
  scholarCover2,
  scholarCover3,
  scholarCover4,
  scholarCover5,
  scholarProfile1,
  scholarProfile2,
  scholarProfile3,
  scholarProfile4,
  scholarProfile5,
} from "../assets";
import { myNFTs } from "./dummyNfts";

export const scholarsList = [
  {
    id: 1,
    name: "Gregory",
    profilePic: scholarProfile1,
    coverPic: scholarCover1,
    address: "mrFYLJRhgULb7ZL7SyKhdGnKHvTxXxkXPG",
    totalNfts: 38,
    split: "24%",
    earnings: "$3,585",
    timePlayed: "400h",
    nfts: myNFTs.filter((nft) => nft.status === "Available"),
    lastActive: "1 Day ago",
  },
  {
    id: 2,
    name: "Zain",
    profilePic: scholarProfile2,
    coverPic: scholarCover2,
    address: "mrFYLJRhgULb7ZL7SyKhdGnKHvTxXxkXPG",
    totalNfts: 38,
    split: "24%",
    earnings: "$3,585",
    timePlayed: "400h",
    nfts: myNFTs.filter((nft) => nft.status === "Available"),
    lastActive: "1 Day ago",
  },
  {
    id: 3,
    name: "Babar",
    profilePic: scholarProfile3,
    coverPic: scholarCover3,
    address: "mrFYLJRhgULb7ZL7SyKhdGnKHvTxXxkXPG",
    totalNfts: 38,
    split: "24%",
    earnings: "$3,585",
    timePlayed: "400h",
    nfts: myNFTs.filter((nft) => nft.status === "Available"),
    lastActive: "1 Day ago",
  },
  {
    id: 4,
    name: "Neil",
    profilePic: scholarProfile4,
    coverPic: scholarCover4,
    address: "mrFYLJRhgULb7ZL7SyKhdGnKHvTxXxkXPG",
    totalNfts: 38,
    split: "24%",
    earnings: "$3,585",
    timePlayed: "400h",
    nfts: myNFTs.filter((nft) => nft.status === "Available"),
    lastActive: "1 Day ago",
  },
  {
    id: 5,
    name: "Igor",
    profilePic: scholarProfile5,
    coverPic: scholarCover5,
    address: "mrFYLJRhgULb7ZL7SyKhdGnKHvTxXxkXPG",
    totalNfts: 38,
    split: "24%",
    earnings: "$3,585",
    timePlayed: "400h",
    nfts: myNFTs.filter((nft) => nft.status === "Available"),
    lastActive: "1 Day ago",
  },
];

export const dummyNftsForScholarProfileDetails = [
  { image: disabledNft1 },
  { image: disabledNft2 },
  { image: disabledNft3 },
  { image: disabledNft4 },
  { image: disabledNft5 },
];

export const dummyGamesForScholarProfileDetails = [
  { image: disableGame1, collectionName: "Sandbox" },
  { image: disableGame2, collectionName: "Sandbox" },
  { image: disableGame3, collectionName: "Sandbox" },
  { image: disableGame4, collectionName: "Sandbox" },
];
